import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";

const JavaScriptLesson2 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>Standardization of Javascript</strong></h3>
       <p>To ensure consistency and interoperability across different implementations and environments where JavaScript is used, it is important to have standardization processes and procedures in place.</p>
       <p>The standardization efforts are primarily managed by the <strong>ECMA International standards organization</strong> through the ECMAScript specification.</p>

       <div class="alert alert-secondary" role="alert">
       <h4><strong>What is ECMAScript?</strong></h4>
       <p><b class="text-dark">ECMA</b> stands for <b class="text-dark">European Computer Manufacturers Association</b>, <b class="text-dark">ES</b> for short.</p>
       <ul class="mb-4">
           <li>ECMAScript is the standardized specification for JavaScript, providing rules, details, and guidelines for the language's implementation.</li>
           <li>The ECMAScript specification defines the syntax, semantics, and behavior of JavaScript.</li>
           <li>It standardizes core features of the language, including data types, control structures, functions, objects, and more.</li>
       </ul>
       <h5>Evolution of ECMAScript:</h5>
       <ul class="mb-4">
           <li><strong>ECMAScript 1 (ES1):</strong> Published in 1997, this was the initial version of the standard, based on the original JavaScript by Netscape.</li>
           <li><strong>ECMAScript 2 and 3:</strong> Released in 1998 and 1999 respectively, introduced minor updates and corrections to the language.</li>
           <li><strong>ECMAScript 4 (Abandoned):</strong> A major overhaul was proposed, but disagreements and concerns over complexity led to its abandonment.</li>
           <li><strong>ECMAScript 5 (ES5):</strong> Released in 2009, introduced significant improvements and new features like strict mode, JSON support, and more.</li>
           <li><strong>ECMAScript 6 (ES6) or ECMAScript 2015:</strong> Released in 2015, brought substantial changes, including arrow functions, classes, modules, and enhanced syntax.</li>
           <l><strong>Annual Releases (ES2016, ES2017, etc.):</strong> ECMAScript moved to a yearly release cycle, introducing new features and enhancements in smaller, more frequent updates.</l>
           <li><strong>TC39 Committee:</strong> The Technical Committee 39 (TC39) manages the ECMAScript standardization process, consisting of various stakeholders, including browser vendors and experts.</li>
       </ul>
       <h5>How New Changes are Adopted</h5>
       <ul class="mb-4">
           <li><strong>Stage Proposals:</strong> New features go through a multi-stage process (Stages 0 to 4) within TC39 to become part of the ECMAScript standard.</li>
           <li><strong>Transpilation:</strong> Developers often use transpilers like Babel to write code using the latest ECMAScript features and convert it to older versions for wider browser support.</li>
           <li><strong>Browser Support:</strong> Browser vendors implement ECMAScript features gradually, providing support for newer features over time.</li>
       </ul>
       </div>
       <p>ECMAScript's standardization has been fundamental in maintaining the language's integrity, fostering innovation, and ensuring compatibility across diverse development ecosystems.</p>

       <p>The 6th edition was a major update that brought many enhancements over ES5, including notably <b class="text-danger">template strings, expressive arrow function syntax,</b> and cleaner syntax for defining classes.</p>
       <p>Because new syntax and features are coming to JavaScript each year, support for these changes is often incomplete in current browsers and the latest Node.js. This doesn't mean we can't use it. Tools such as Babel offer transpilation for most features, allowing us to write as if it's the future.</p>
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson2
